import { render, staticRenderFns } from "./InfoDefault.vue?vue&type=template&id=b2f47bca&scoped=true&"
import script from "./InfoDefault.vue?vue&type=script&lang=js&"
export * from "./InfoDefault.vue?vue&type=script&lang=js&"
import style0 from "./InfoDefault.vue?vue&type=style&index=0&id=b2f47bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f47bca",
  null
  
)

component.options.__file = "InfoDefault.vue"
export default component.exports